module.exports = __webpack_public_path__ + "img/title.eb4e4ba0.png";